import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { CheckboxSelectionCard } from '@soluto-private/mx-asurion-ui-react';

import { kebabize } from '@service-initiation/shared-utils-helpers';
import { TranslationEntries } from '@service-initiation/tech-care-data-access-i18n';
import {
  useRepairMessageValue,
  useSelectedRepairsAsyncAtom,
} from '@service-initiation/tech-care-data-access-store';
import { type Repair } from '@service-initiation/tech-care-data-access-tech-care-services';

import { TextArea } from './TextArea';

const TEXTS = TranslationEntries.Repairs.DamageType;

const StyledCheckBoxSelectionCard = styled(CheckboxSelectionCard)`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: start;
  margin-bottom: 12px;
`;

const CheckBoxText = styled.span`
  width: 100%;
`;

export type DamageFormProps = {
  damages: Repair[];
  handleDamageSelection: (damage: Repair) => void;
  handleTextAreaChange: (value: string) => void;
};

export const DamageForm = ({
  damages,
  handleDamageSelection,
  handleTextAreaChange,
}: DamageFormProps) => {
  const { t } = useTranslation();
  const { value: selectedRepairs } = useSelectedRepairsAsyncAtom();
  const repairMessage = useRepairMessageValue();

  return (
    <div>
      {damages?.length > 1 && (
        <div data-testid="damage-type-peril-checkbox-container">
          {damages.map((damage) => (
            <StyledCheckBoxSelectionCard
              checked={!!selectedRepairs?.find((dmg) => dmg.id === damage.id)}
              key={damage.id}
              onClick={() => handleDamageSelection(damage)}
            >
              <CheckBoxText
                data-testid={`damage-card-${kebabize(
                  damage?.repairType?.symptom === "I don't know / Other"
                    ? 'i-dont-know'
                    : damage?.repairType?.symptom
                )}`}
              >
                {damage.repairType?.symptom}
              </CheckBoxText>
            </StyledCheckBoxSelectionCard>
          ))}
        </div>
      )}
      <TextArea
        data-testid="damage-free-form-text-area"
        label={t(TEXTS.FreeFormLabelNoPerilImages)}
        onChange={handleTextAreaChange}
        value={repairMessage}
      />
    </div>
  );
};
